import React from 'react';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';

import { useAppContext } from '../lib/context';
import { ReactComponent as CautionIcon } from '../assets/svg/caution.svg';
import { ReactComponent as CheckIcon } from '../assets/svg/check.svg';

const Notifications = () => {
  const { notifications, setNotifications } = useAppContext();

  return (
    <ToastContainer position='top-end' className='p-3 z-full position-absolute'>
      <Toast
        show={notifications !== null}
        onClose={() => setNotifications(null)}
        delay={4000}
        autohide
      >
        <Toast.Header>
          {notifications?.icon === 'danger' && (
            <CautionIcon height='24' className='text-danger me-3' />
          )}
          {notifications?.icon === 'success' && (
            <CheckIcon height='24' className='text-success me-3' />
          )}
          <strong className='me-auto'>{notifications?.title}</strong>
        </Toast.Header>
        <Toast.Body>
          <ul className='list-unstyled'>
            {notifications?.messages.map((message) => (
              <li key={message}>{message}</li>
            ))}
          </ul>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default Notifications;
